export const queryKeys = {
  base: () => ['system'] as const,
};
